import { useEffect, useCallback, RefObject } from "react";

const useKeyboardAccessibility = (
  ref: RefObject<HTMLElement>,
  callback: () => void
) => {
  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        callback();
      }
    },
    [callback]
  );

  useEffect(() => {
    const currentElement = ref.current;

    if (currentElement) {
      currentElement.addEventListener("keydown", handleKeyPress);
    }

    return () => {
      if (currentElement) {
        currentElement.removeEventListener("keydown", handleKeyPress);
      }
    };
  }, [ref, handleKeyPress]);
};

export default useKeyboardAccessibility;